export default "__VITE_ASSET__qxde7_6A__"